import { useEffect, useRef, useState } from "react"
import { useSelector } from "react-redux"
import * as shortcutMessageApis from "../utilities/apis/shortcutMessage"

const ShortMessagesModal = (props) => {
  const { token } = useSelector(state => state.user)
  const modalRef = useRef(null)
  const [messages, setMessages] = useState([])

  const getShortcutMessages = async () => {
    try {
      const response = await shortcutMessageApis.getShortcutMessages(token, "")
      if (!response.status) throw new Error(response.message)

      setMessages(response.shortcut_messages)
    } catch (error) {
      setMessages([])
    }
  }

  useEffect(() => {
    // Refresh the list every time the modal opens so newly added shortcuts show up
    const modal = modalRef.current
    modal.addEventListener("show.bs.modal", getShortcutMessages)

    return () => modal.removeEventListener("show.bs.modal", getShortcutMessages)
  }, [token])

  return (
    <div ref={modalRef} className="modal fade" id="shortMessagesModal" tabIndex="-1" aria-labelledby="shortMessagesModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-md modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5 fw-bold" id="shortMessagesModalLabel">Shortcut Messages</h1>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body p-0">
            <div className="list-group list-group-flush">
              {messages.length === 0 && <p className="text-center text-muted small m-0 p-3">No short messages</p>}
              {messages.map((row) => {
                return (
                  <button key={row.id} type="button" className="list-group-item list-group-item-action" onClick={() => props.handleSelect(row.message)} data-bs-dismiss="modal">
                    <span className="fw-bold">{row.shortcut}</span><br />
                    <span className="small text-break" style={{ whiteSpace: "pre-wrap" }}>{row.message}</span>
                  </button>
                )
              })}
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ShortMessagesModal
